import ActionModal from './ActionModal'

interface LogoutConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * 退出登录确认弹窗
 * 使用通用的 ActionModal 实现
 */
export default function LogoutConfirmModal(props: LogoutConfirmModalProps) {
  return (
    <ActionModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
      title='Sign out'
      description='Are you sure you want to sign out?'
      confirmText='Sign out'
      confirmTestId='logout-confirm-button'
      cancelText='Cancel'
      cancelTestId='logout-cancel-button'
      testId='logout-modal'
    />
  )
}
